import { IdCardType, type InsurancePlan } from 'src/services/interfaces/insurance';

export interface CardDefaults {
  groupNumber?: string;
  rxGroupNumber?: string;
}

const CIGNA_GROUP_NUMBER = 'HC002';

const trimValue = (value: unknown): string => {
  if (value == null) return '';
  return String(value).trim();
};

const getPlanDefault = (
  plan: InsurancePlan | undefined,
  key: 'groupNumber' | 'rxGroupNumber'
): string => {
  if (!plan) return '';

  const planValue = trimValue((plan as unknown as Record<string, unknown>)[key]);
  if (planValue) return planValue;

  const details = plan.details as Record<string, unknown> | undefined;
  return trimValue(details?.[key]);
};

export function getCardDefaultsForPlan(plan?: InsurancePlan | string): CardDefaults {
  const planObject = typeof plan === 'string' ? undefined : plan;
  const groupNumber = getPlanDefault(planObject, 'groupNumber');
  const rxGroupNumber = getPlanDefault(planObject, 'rxGroupNumber');

  if (planObject?.idCard === IdCardType.CignaMedical) {
    return {
      groupNumber: groupNumber || CIGNA_GROUP_NUMBER,
      rxGroupNumber: rxGroupNumber || CIGNA_GROUP_NUMBER,
    };
  }

  return {
    groupNumber: groupNumber || undefined,
    rxGroupNumber: rxGroupNumber || undefined,
  };
}

export function resolveIdCardNumbers({
  plan,
  groupId,
  rxGroupId,
}: {
  plan?: InsurancePlan;
  groupId?: unknown;
  rxGroupId?: unknown;
}): Required<CardDefaults> {
  const defaults = getCardDefaultsForPlan(plan);
  const cignaFallback = plan?.idCard === IdCardType.CignaMedical ? CIGNA_GROUP_NUMBER : '';
  const groupNumber =
    trimValue(groupId) ||
    trimValue(defaults.groupNumber) ||
    trimValue(defaults.rxGroupNumber) ||
    cignaFallback;
  const rxGroupNumber =
    trimValue(rxGroupId) ||
    trimValue(defaults.rxGroupNumber) ||
    trimValue(defaults.groupNumber) ||
    cignaFallback;

  return {
    groupNumber,
    rxGroupNumber,
  };
}
